import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=b4b8f12e"
import script from "./ChatAvatar.vue?vue&type=script&lang=js"
export * from "./ChatAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports